import axios from 'axios';

const API_BASE =
    process.env.REACT_APP_API_BASE ||
    (window.location.port === '3000' ? 'http://localhost:3001' : '');

const toDateParam = (date) => (date ? date.toISOString().split('T')[0] : null);

export const fetchRootCauseFilters = async ({ selectedFamilies = [] } = {}) => {
    const params = {
        selectedFamilies: selectedFamilies.join(',') || undefined,
    };
    const [stepsResponse, serialResponse, versionResponse, testspecResponse] = await Promise.all([
        axios.get(`${API_BASE}/api/root-cause-primary-steps`, { params }),
        axios.get(`${API_BASE}/api/distinct-serial-numbers`),
        axios.get(`${API_BASE}/api/ate-sw-versions`),
        axios.get(`${API_BASE}/api/testspecs`),
    ]);

    return {
        stepNumbers: stepsResponse.data || [],
        serialNumbers: (serialResponse.data || []).map((serialNumber) => ({
            value: serialNumber,
            label: serialNumber,
        })),
        ateSwVersions: (versionResponse.data || []).map((version) => ({
            value: version.AteSwVersion,
            label: version.AteSwVersion,
        })),
        testspecs: (testspecResponse.data || []).map((item) => ({
            value: item.Testspec,
            label: item.Testspec,
        })),
    };
};

export const fetchRootCauseAnalysis = async ({
    selectedStepNumber,
    startDate,
    endDate,
    ateSwVersion,
    selectedSerialNumbers,
    selectedFamilies = [],
    selectedTestspec = '',
}) => {
    const response = await axios.get(`${API_BASE}/api/root-cause-analysis`, {
        params: {
            stepNumber: selectedStepNumber || undefined,
            startDate: toDateParam(startDate),
            endDate: toDateParam(endDate),
            ateSwVersion: ateSwVersion || undefined,
            serialNumbers: selectedSerialNumbers.map((serialNumber) => serialNumber.value).join(','),
            selectedFamilies: selectedFamilies.join(',') || undefined,
            Testspec: selectedTestspec || undefined,
        },
    });

    return response.data || { candidates: [], summary: {}, context: [] };
};
